import {
  ApiGetHook,
  ApiMutateHook,
  useApiGet,
  useApiMutate,
} from "@skanska/vsa-client-auth";
import { ApiEndpoints } from "../models/ApiEndpoints";
import { ApiMethods } from "../models/ApiMethods";
import { UtilityLinks } from "../models/UtilityLinks";

export function useUtilityLinksGet(): ApiGetHook<UtilityLinks> {
  return useApiGet<UtilityLinks>(
    ApiEndpoints.UtilityLinks,
    null,
    "utility-links"
  );
}

export function useUpdateUtilityLinks(): ApiMutateHook<
  UtilityLinks,
  UtilityLinks
> {
  return useApiMutate<UtilityLinks, UtilityLinks>(
    ApiEndpoints.UtilityLinks,
    ApiMethods.Patch,
    null,
    null,
    ["utility-links"]
  );
}
